import { Theme } from '@mui/material'

const useStyles = {
  locationCardContainer: (theme: Theme) => ({
    alignItems: 'flex-start',
    borderRadius: 1,
    paddingY: 1.5,
    paddingX: 2,
    gap: 2,
    bgcolor: theme.palette.background.paper,
  }),
  locationCardTextColumn: {
    gap: '6px',
  },
  locationCardDeviceName: {
    fontWeight: '400',
  },
}

export default useStyles
